module.exports = __webpack_public_path__ + "img/skip-forward-btn-fill.40e9f432.svg";